<main class="main-content has-sidebar-details">
    <div>
        <div class="bg-brand-purple-50 p-8">
            <div class="flex items-center justify-between gap-6">
                <h2 class="page-title">
                    <button (click)="voltarParaListas($event)" class="flex text-brand-primary" style="cursor: pointer;">
                        <span class="material-symbols-outlined">
                            arrow_left_alt
                        </span>
                    </button>
                    <span class="page-title-text-wrapper">
                        <span class="page-title-text">{{nomeLista}}</span>
                    </span>
                </h2>
                <div class="flex items-center gap-6">
                    <div 
                        class="dropdown" 
                        [title]="permissaoService.hasPermission(EnumPermissao.ExportarLista) ? 'Exportar lista' : 'Você não tem permissão para exportar a lista'"
                        [class.cursor-blocked] = "!permissaoService.hasPermission(EnumPermissao.ExportarLista) || exportandoLista"                        
                    >
                        <button 
                            class="btn btn-primary dropdown-toggle" 
                            type="button" 
                            data-bs-toggle="dropdown"
                            aria-expanded="false" 
                            [disabled]="!permissaoService.hasPermission(EnumPermissao.ExportarLista) || exportandoLista"
                        >
                            <span *ngIf="!exportandoLista">Exportar lista</span>
                            <span *ngIf="exportandoLista">Exportando lista...</span>
                        </button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item dropdown-item-link" (click)="exportarLista(EnumTipoDownload.CSV)">CSV</a></li>
                            <li style="display: none;"><a class="dropdown-item" href="#">TXT</a></li>
                            <li><a class="dropdown-item dropdown-item-link" (click)="exportarLista(EnumTipoDownload.XLSX)">XLSX</a></li>
                        </ul>
                    </div>
                    <button class="text-brand-primary" style="cursor: default;">
                        <span class="material-symbols-outlined filled">
                            view_week
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="main-content__area">
            <app-carregando [showCarregando]="carregando" [isChart]="false" containerHeight="50vh" spinnerSize="40px">
            </app-carregando>
            <div class="py-5" [class.hidden]="carregando">
                <div class="table__wrapper">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover dataTable"
                        id="tblContatos">
                    </table>
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </div>
    </div>
    <app-modal-contato 
        *ngIf="showDetails" 
        [idContato]="idContatoDetalhes" 
        [idLista]="idLista"
        (fecharDetalhes)="closeDetails()" 
        (contatoConvertidoEvent)="onContatoConvertido($event)" 
        (contatoRemoverVendaEvent)="onContatoRemoverVenda($event)">
    </app-modal-contato>
</main>